import { EngagementActions as ListViewEngagementActions } from "../ListViewItem/EngagementActions";

// TODO: Refactor the actions out, we are going to just always refetch the post so don't have to do any complex logic.
export const EngagementActions = () => (
  <ListViewEngagementActions type="card" />
);
